import type { LessonVersion, VrLessonVersion, GameLessonVersion } from "models/LessonVersion";
import { LessonType } from "models/LessonType";

function vrVersions(versions: LessonVersion[]): VrLessonVersion[] {
    return versions.filter((v): v is VrLessonVersion => v.type === LessonType.VR);
}

function gameVersions(versions: LessonVersion[]): GameLessonVersion[] {
    return versions.filter((v): v is GameLessonVersion => v.type === LessonType.GAME);
}

export const findVersionByLanguage = (
    versions: LessonVersion[],
    language: string
): VrLessonVersion | undefined =>
    vrVersions(versions).find((v) => v.language === language);

export const findGameVersionByLanguage = (
    versions: LessonVersion[],
    language: string
): GameLessonVersion | undefined =>
    gameVersions(versions).find((v) => v.language === language);

export const findAnyVersionByLanguage = (
    versions: LessonVersion[],
    language: string
): LessonVersion | undefined =>
    versions.find((v) => v.language === language);

export const findDefaultVersion = (
    versions: LessonVersion[]
): VrLessonVersion | undefined =>
    vrVersions(versions).find((v) => v.isDefault);

export const findDefaultGameVersion = (
    versions: LessonVersion[]
): GameLessonVersion | undefined =>
    gameVersions(versions).find((v) => v.isDefault);


export const getInitialVersion = (
    versions: LessonVersion[],
    preferredLanguage: string
): LessonVersion | null => {
    const vr = vrVersions(versions);
    const game = gameVersions(versions);

    if (vr.length > 0) {
        return (
            findVersionByLanguage(versions, preferredLanguage) ??
            findDefaultVersion(versions) ??
            vr[0]
        );
    }
    if (game.length > 0) {
        return (
            findGameVersionByLanguage(versions, preferredLanguage) ??
            findDefaultGameVersion(versions) ??
            game[0]
        );
    }
    return null;
};
